export const settingsUrl = '/settings'
export const settingsAccountUrl = `${settingsUrl}/account`
export const settingsBrandUrl = `${settingsUrl}/brand`
export const settingsContentUrl = `${settingsUrl}/content`
export const settingsContentPagesUrl = `${settingsUrl}/content/pages`
export const settingsPeopleUrl = `${settingsUrl}/people`
export const settingsPeopleRoleUrl = `${settingsUrl}/people/role`
export const settingsSiteUrl = `${settingsUrl}/site`
export const settingsSiteReportsUrl = `${settingsUrl}/site/reports`
